<template>
  <div>
    <div v-if="product">
      <selling-install-banner v-if="!shop.verified" :shop="shop" class="fixed bottom-5 right-5"/>
      <div ref="confirmation"
           class="bg-black text-white p-2 text-center fixed top-0 left-0 w-full z-10 invisible opacity-0 transition-opacity duration-300">
        {{ product.title }} added to your cart
      </div>

      <div class="grid lg:grid-cols-2 grid-cols-1 gap-4">
        <div class="mb-6">
          <product-gallery :product="product"/>
        </div>
        <div class="mx-5 mt-5">
          <product-info :product="product" class="mb-10"/>
          <product-variants v-model="variantId" :product="product" class="my-10"/>
          <div class="w-full lg:w-3/4">
            <product-button :disabled="!variantId" :loading="loading" @click="addToCart">
              ADD TO CART
            </product-button>
          </div>
          <product-details :product="product" :shop-handle="shopHandle" class="my-10"/>
        </div>
      </div>
    </div>
    <div v-else class="fixed inset-0 flex items-center justify-center">
      <spinner/>
    </div>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({layout: 'shop'})
import {useCartStore} from "~/store/cart";

const {shophandle: shopHandle, producthandle: productHandle} = useRoute().params
const product = await useProduct(shopHandle as string, productHandle as string)

const title = computed(() => product?.title || "Product")
useHead({
  title
})

const variantId = ref<string | undefined>(undefined)
const shop = await useShopData(shopHandle as string)
const confirmation = ref<HTMLElement | null>(null)
const loading = ref<boolean>(false)

const addToCart = async () => {
  if (!variantId.value) {
    return
  }
  loading.value = true
  try {
    const {addToCart} = useCartStore()
    await addToCart(product.product_id, variantId.value, product.price.currency, shopHandle as string)
    if (confirmation.value) {
      confirmation.value.classList.remove('invisible', 'opacity-0');
      setTimeout(() => {
        confirmation.value.classList.add('invisible', 'opacity-0');
      }, 2000);
    }
  } finally {
    loading.value = false
  }
}


onMounted(() => {
  useTrackEvent(
      'view_item',
      {
        currency: product.price.currency,
        value: product.price.amount / 100,
        items: [
          {
            item_id: product.product_id,
            item_name: product.title,
            index: 0,
            item_brand: shopHandle,
            quantity: 1,
            price: product.price.amount / 100
          }
        ]
      }
  )
})

</script>